export const footerOne = [
    'Computers',
    'Phones',
    'Tablets',
    'Consoles',
    'Accesseries',
    'Laptops',
]

export const footerTwo = [
    {name:'Sony', link: 'https://www.sony.com/en/'},
    {name:'Samsung', link: 'https://www.samsung.com/'},
    {name:'Apple', link: 'https://www.apple.com/'},
    {name:'HP', link:'https://www.hp.com/us-en/home.html'},
    {name:'Lenovo', link: 'https://www.lenovo.com/us/en/'},
]

export const cartTitles = [
    'Product',
    'Price',
    'Quantity',
    'Total',
]

export const filters = [
    'All Products',
    'Phones',
    'Computers',
    'Others',
]



export const navs = [
    { nav: 'Home', path: '/' },
    { nav: 'Gallery', path: '/gallery' },
    { nav: 'Sale', path: '/sale' },
    { nav: 'Contact', path: '/contact' },
  ]

export const filtersTwo = [
    'All Products',
    'Mobile Phones',
    'Laptop Computers',
    'Head Phones',
    'Smart Televisions',
    'Game Consoles',
    'Others',
]

export const path = 'https://shopping-app-backend-phi.vercel.app/api/v1' 